import React from 'react';
import { AlertCircle } from 'lucide-react';
export function PainSection() {
  return <section className="py-16 px-4 bg-white/50" data-id="element-92">
      <div className="max-w-2xl mx-auto" data-id="element-93">
        <div className="text-center mb-10" data-id="element-94">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3648] mb-4" data-id="element-95">
            El dolor que muchas mamás viven en silencio
          </h2>
          <p className="text-[#4A5568] text-lg" data-id="element-96">
            Ver a tu hijo sufrir frente a un libro es una de las experiencias
            más difíciles de la maternidad. No es solo lectura, es su
            autoestima.
          </p>
        </div>

        <div className="bg-[#F5F1EA] rounded-2xl p-8 border border-[#5C6B60]/10 shadow-sm" data-id="element-97">
          <ul className="space-y-4" data-id="element-98">
            <li className="flex items-start" data-id="element-99">
              <div className="bg-[#C2644C]/10 p-1.5 rounded-full mr-3 mt-0.5" data-id="element-100">
                <AlertCircle className="w-5 h-5 text-[#C2644C]" data-id="element-101" />
              </div>
              <span className="text-[#4A5568] text-lg" data-id="element-102">
                Se compara constantemente con sus compañeros.
              </span>
            </li>
            <li className="flex items-start" data-id="element-103">
              <div className="bg-[#C2644C]/10 p-1.5 rounded-full mr-3 mt-0.5" data-id="element-104">
                <AlertCircle className="w-5 h-5 text-[#C2644C]" data-id="element-105" />
              </div>
              <span className="text-[#4A5568] text-lg" data-id="element-106">
                Evita participar en clase por miedo a equivocarse.
              </span>
            </li>
            <li className="flex items-start" data-id="element-107">
              <div className="bg-[#C2644C]/10 p-1.5 rounded-full mr-3 mt-0.5" data-id="element-108">
                <AlertCircle className="w-5 h-5 text-[#C2644C]" data-id="element-109" />
              </div>
              <span className="text-[#4A5568] text-lg" data-id="element-110">
                Su seguridad baja cada día que pasa sin avanzar.
              </span>
            </li>
            <li className="flex items-start bg-white p-4 rounded-xl border-l-4 border-[#C2644C] shadow-sm" data-id="element-111">
              <div className="bg-[#C2644C]/10 p-1.5 rounded-full mr-3 mt-0.5" data-id="element-112">
                <AlertCircle className="w-5 h-5 text-[#C2644C]" data-id="element-113" />
              </div>
              <span className="text-[#2D3648] text-lg font-medium" data-id="element-114">
                Empieza a pensar y decir:{' '}
                <span className="text-[#C2644C] font-bold" data-id="element-115">
                  "No soy inteligente."
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}